module.exports = __webpack_public_path__ + "img/beijing.5ddf6dbd.png";